import React from 'react';
import { each } from 'lodash';
import PropTypes from 'prop-types';

export const FormContext = React.createContext();

export const setError422 = (err, setFieldError) => {
  if (err?.response?.error === 'unprocessable_entity') {
    each(err?.response?.errors, (v, k) => {
      setFieldError(k, v);
    });
  }
};

export const ErrorLabel = ({ name }) => {
  const { error } = React.useContext(FormContext);
  if (!error[name]) return null;

  return (
    <div className="text-xs bg-red-50 text-red-500 -mt-1 relative z-0 rounded-b px-2 pb-2 pt-3">
      {typeof error[name] === 'string' ? error[name] : 'Invalid'}
    </div>
  );
};

ErrorLabel.propTypes = {
  name: PropTypes.string.isRequired,
};

export const ErrorOrDescription = ({ name, label }) => {
  const { error } = React.useContext(FormContext);
  if (!error[name])
    return (
      <div className="text-xs bg-gray-100 -mt-1 relative z-0 rounded-b px-2 pb-2 pt-3 text-gray-500">
        {label}
      </div>
    );
  return (
    <div className="text-xs bg-red-50 text-red-500 -mt-1 relative z-0 rounded-b px-2 pb-2 pt-3">
      {error[name]}
    </div>
  );
};

ErrorOrDescription.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

function Form({ onSubmit, children, error, ...props }) {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit();
  };
  return (
    /* eslint-disable-next-line react/jsx-no-constructed-context-values */
    <FormContext.Provider value={{ error }}>
      <form onSubmit={handleSubmit} {...props}>
        {children}
      </form>
    </FormContext.Provider>
  );
}

Form.defaultProps = {
  error: {},
};

Form.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.instanceOf(Object),
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  error: PropTypes.instanceOf(Object),
};

export default Form;
